"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Money_1 = __importDefault(require("components/Money"));
var DoubleCell_1 = __importDefault(require("containers/TableMaker/components/DoubleCell"));
var utils_1 = require("../../utils");
var ListPrice = function (_a) {
    var item = _a.item;
    return ((0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: item.listPrice, fallbackText: "-", isRounded: true }), secondary: item.billingCycle ? "(Billed ".concat(utils_1.BILLING_FREQ_MAPPER[item.billingCycle.months || 0], ")") : '(One-time Fee)' }));
};
exports.default = ListPrice;
